import React from "react";
import { Route, Switch } from "react-router-dom";
import ItemList from "./ItemList";
import Export from "../../Export/Export";
import ErrorsWarnings from "../ErrorsWarnings/ErrorsWarnings";
import TritonConverter from "../../TritonConverter";

const EditorRouter = () => {
  return (
    <Switch>
      <Route exact path="/:id" component={ItemList} />
      <Route exact path="/:id/archive">
        <ItemList archivedOnly />
      </Route>
      <Route exact path="/:id/export" component={Export} />
      <Route exact path="/:id/errors-warnings" component={ErrorsWarnings} />
      <Route exact path="/:id/triton" component={TritonConverter} />
      <Route
        exact
        path="/:id/collection/:collection"
        render={(props) => (
          <ItemList collection={decodeURIComponent(props.match.params.collection)} />
        )}
      />
      <Route
        exact
        path="/:id/tag/:tag"
        render={(props) => (
          <ItemList tag={decodeURIComponent(props.match.params.tag)} />
        )}
      />
      <Route>
        <ItemList />
      </Route>
    </Switch>
  );
};

export default EditorRouter;
